<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-08-01 
-->
<template>
  <div class="main-container">
    <page-header v-if="moduleId == 1">{{'新闻资讯' | dealLanguage('News')}}</page-header>
    <page-header v-if="moduleId == 2">China CGT 100 Pioneers</page-header>
    <div class="warp">
      <div class="news">
        <news-item v-for="item,index in list" :key="index" :itemDetail="item"></news-item>
      </div>
      <div class="loading-warpper" v-if="loading">
        <van-loading size="20px">加载中...</van-loading>
      </div>
      <div class="list-over" v-if="!isMore && !loading && list.length > 0">{{'已经到底了~' | dealLanguage('No more content to load.')}}</div>
      <nothing v-if="!isMore && !loading && list.length == 0" :title="language == 'zh' ? '暂无相关资讯' : 'No relevant information'">
        <router-link :to="{name: 'index'}" class="btn">{{'返回首页' | dealLanguage('Home')}}</router-link>
      </nothing>
      <div ref="indexlist-bottom"></div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import { getActAppMi } from '@/service/vbef'
import PageHeader from '@/components/pc/pageHeader.vue'
import NewsItem from '@/components/index/newsItem.vue'
import { mapState } from 'vuex'
export default {
  metaInfo() {
    return {
      title: this.moduleId == 1 ? (this.language == 'zh' ? '新闻资讯' : 'News') : 'China CGT 100 Pioneers', 
    }
  },
  components: {
    Nothing,
    PageHeader,
    NewsItem,
  },
  created() {
    this.moduleId = this.$route.query.type || 1
    this.getList()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      list: [],
      loading: false,
      isMore: false,
      moduleId: 1
    }
  },
  computed: {
    ...mapState({
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  methods: {
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const listbox = this.$refs['indexlist-bottom']
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop
      if (
        scrollTop + windowHeight >= listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.isMore
      ) {
        this.getMore()
      }
    },
    async getList() {
      this.loading = true
      let res = await getActAppMi({
        page: this.page,
        size: 12,
        activityId: this.activityId,
        isEnglish: this.language == 'en' ? 1 : 0,
        moduleId: this.moduleId
      })
      this.loading = false
      if (res.code == 0) {
        this.list = [...this.list, ...res.data]
        this.isMore = res.data.length == 12
      }
    },
    getMore() {
      this.page++
      this.getList()
    },
  },
  watch: {
    '$route.query.type'(val) {
      this.moduleId = val || 1
      this.page = 1
      this.list = []
      this.getList()
    }
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.warp
  margin-top 30px
  padding-bottom 40px
.news
  display flex
  flex-wrap wrap
  >>> .news-item
    &:not(:nth-of-type(3n+1))
      margin-left 66px
    &:nth-of-type(n+4)
      margin-top 40px
</style>